import axios, {AxiosInstance} from 'axios';

const instance: AxiosInstance = axios.create({
    baseURL: 'https://hookahapp.ru',
    headers: {
        'Accept': 'application/json',
    },
});

/*
instance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    console.log(response);
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});
*/

export const AccountAPI = {
    getAuthToken(uuid: any) {
        return instance.post(`/account/auth_token?deviceId=${uuid}`, {
            headers: {'Accept': 'text/plain'},
        })
            .then(res => instance.defaults.headers.common['Authorization'] = `Bearer ${res.data}`)
            .catch(e => console.log(e));
    },
    getAccountPreferences() {
        return instance.get(`/account/preferences`)
            .then(res => res.data)
            .catch(e => console.log(e));
    },
    updateAccountPreferences(activeBrandsId: Array<number>, activeHardness: number, activeTastesId: Array<number>) {
        return instance.put(`/account/preferences/update`, {
                brandIds: activeBrandsId,
                hardness: activeHardness,
                tasteIds: activeTastesId
            },
        )
            .then((res: { data: any; }) => res)
            .catch((e: any) => console.log(e));
    }

};

export const BrandsAPI = {
    getBrands() {
        return instance.get(`/brands`)
            .then(res => res.data)
            .catch(e => console.log(e));
    },
    getFullInfoBrand(id: number) {
        return instance.get(`/brands/${id}/tobaccos`)
            .then(res => res.data)
            .catch(e => console.log(e));
    },
};

export const MixesAPI = {
    getMixWeek() {
        return instance.get(`/mixes/week`)
            .then(res => res.data)
            .catch(e => console.log(e));
    },
    getPopularMixes() {
        return instance.get(`/mixes/popular`)
            .then(res => res.data)
            .catch(e => console.log(e));
    },
    getMixCompilations() {
        return instance.get(`/mixes/compilations`)
            .then(res => res.data)
            .catch(e => console.log(e));
    },
    getMixCompilation(id: number) {
        return instance.get(`/mixes/compilations/${id}`)
            .then(res => res.data)
            .catch(e => console.log(e));
    },
    getMixesRecommended() {
        return instance.get(`/mixes/recommended`)
            .then(res => res.data)
            .catch(e => console.log(e));
    },
    getMixesPreference(activeBrandsId: Array<number>, activeHardness: number, activeTastesId: Array<number>) {
        return instance.post(`/mixes/random`, {
            tasteIds: activeTastesId,
            hardness: activeHardness,
            brandIds: activeBrandsId,
        })
            .then(res => res.data)
            .catch(e => console.log(e));
    },
    getMixer(tastesID: Array<number>) {
        return instance.post(`/mixes/random/tobacco`, {
            tobaccoIds: tastesID
        })
            .then(res => res.data)
            .catch(e => console.log(e));
    },
    likeMix(id: number) {
        return instance.post(`/mixes/like/${id}`, null, {

        })
            .then(res => res.data)
            .catch(e => console.log(e));
    },
    unlikeMix(id: number) {
        return instance.post(`/mixes/unlike/${id}`)
            .then(res => res.data)
            .catch(e => console.log(e));
    },
    getOneRandomMix() {
        return instance.get(`/mixes/random/one`)
            .then(res => res.data)
            .catch(e => console.log(e));
    },
    getMixesByIds(ids: Array<number>) {
        return instance.get(`/mixes`, {
            params: {
                ids: ids
            }
        })
            .then(res => res.data)
            .catch(e => console.log(e));
    }
};

export const TastesAPI = {
    getListTastes() {
        return instance.get('/tastes', {})
            .then(res => res.data)
            .catch(e => console.log(e));
    },
};
